import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";

import App from "./pages/App";

import { persistStore, autoRehydrate, createTransform } from "redux-persist";

import createRootReducer from "./reducers";

import { appAxiosMiddleware } from "./redux_axios_middleware";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { makeMigrationMiddleware } from "./redux_migration";

import dayjs from "./utils/dayjs";

import "./index.css";
import { SYNC_STORE_KEYS } from "./syncConfig";

import * as Sentry from "@sentry/browser";

window.dayjs = dayjs;

const debugging = window.location.hash === "#debug";
const history = createBrowserHistory();

// eslint-disable-next-line no-unused-vars
function clearPathname(pathname) {
  if (pathname.indexOf("/h/") === 0) {
    return "/h/000"; // strip human name
  }
  return pathname;
}

const composeSetup = // for redux devtools
  import.meta.env.DEV &&
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const objectsPendingTransform = createTransform(
  undefined,
  (outboundState) =>
    outboundState.map((h) => ({
      ...h,
      ...(h.pending ? { modified: true, pending: false } : {}),
    })),
  {
    whitelist: SYNC_STORE_KEYS,
  },
);

const persistConfig = {
  blacklist: ["router", "loading", "humansFilterQuery", "debugLog"],
  transforms: [objectsPendingTransform],
};

const store = createStore(
  createRootReducer(history, debugging),
  composeSetup(
    applyMiddleware(routerMiddleware(history), appAxiosMiddleware),
    autoRehydrate(),
    makeMigrationMiddleware(),
  ),
);

serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.debug("Service worker successfully registered", { registration });
  },
  onUpdate: (registration) => {
    console.info("Service worker update available", { registration });
  },
  onError: (error) => {
    console.error("Service worker registration failed", { error });
    // Report to Sentry
    if (window.Sentry) {
      Sentry.captureException(error);
    }
  },
});

persistStore(store, persistConfig, () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App history={history} debugging={debugging} />
      </ConnectedRouter>
    </Provider>,
    document.getElementById("root"),
  );
});
